<template>
  <div id="jointOrderConstruct">
    <van-cell title="总计" style="font-weight: bold" :value="total" />
    <div class="construct_list">
      <div class="top">
        <ul style="display: flex; justify-content: space-between; width: 100%">
          <li>施工项</li>
          <li>类型</li>
          <li style="flex: 1">单价</li>
          <li>数量</li>
          <li>备注</li>
        </ul>
      </div>
      <div class="list">
        <ul style="width：100%">
          <li
            @click="construct(item, index)"
            v-for="(item, index) in constructDetail"
            :key="index"
            style="display: flex; justify-content: space-between"
          >
            <span>{{ item.projectName }}</span>
            <span>{{
              item.priceType == null ? "" : item.priceType > 1 ? "修补" : "新增"
            }}</span>
            <span style="flex: 1"
              >{{ item.priceType ? (item.price?item.price:0) : 0 }}{{ item.priceType ? item.priceUnit : "" }}</span
            >
            <!-- <span style="flex: 1"
              >{{
                item.price
              }}{{ item.priceType ? item.priceUnit : "" }}</span
            > -->
            <span>{{ item.count }}</span>
            <span>{{ item.remark }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div style="height: 1.2rem"></div>
    <div class="btn">
      <van-button
        round
        block
        type="primary"
        :loading="saveLoad"
        :disabled="saveLoad"
        @click="submit"
        >保存</van-button
      >
    </div>
    <van-popup
      :close-on-click-overlay="false"
      style="width: 90%; padding: 15px 20px; border-radius: 4px"
      v-model="showEdit"
      position="center"
    >
      <h3 style="margin: 0.24rem 0">施工项编辑</h3>
      <van-form @submit="onSubmitForm">
        <van-field
          name="施工项"
          label="施工项"
          readonly
          v-model="projectName"
        />
        <van-field
          name="priceType"
          label="类型"
          :rules="[{ required: true, message: '请填写类型' }]"
        >
          <template #input>
            <van-radio-group
              @change="radioChange"
              v-model="priceType"
              direction="horizontal"
            >
              <van-radio name="1">新增</van-radio>
              <van-radio name="2">修补</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="单价" label="单价" readonly v-model="danjia" />
        <van-field
          type="number"
          name="数量"
          label="数量"
          v-model="count"
          :rules="[{ required: true, message: '请填写数量' }, {
                validator: validNum0,
                message: '数量必须为整数或0',
              },]"
        />
        <van-field
          v-model="remark"
          rows="2"
          autosize
          label="备注"
          type="textarea"
          maxlength="50"
          placeholder="请输入备注"
          show-word-limit
        />
        <div style="margin: 16px; display: flex; justify-content: space-around">
          <van-button
            size="small"
            @click="cancel"
            style="width: 30%"
            round
            block
            type="default"
            native-type="reset"
            >取消</van-button
          >
          <van-button
            size="small"
            style="width: 30%"
            round
            block
            type="primary"
            native-type="submit"
            >确认</van-button
          >
        </div>
      </van-form>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  requestJointOrderConstructDetail,
  requestJointOrderConstructDetailLast,
  requestJointOrderConstructSaveOrUpdate,
} from "@/api";
import { validNum0,validNumMoreDecimal2 } from "@/utils/validate";
import { deepClone,accMul } from "@/utils/index";
export default {
  name: "jointOrderConstruct",
  data() {
    return {
      customerDetail: [],
      showEdit: false,
      constructDetail: [],
      radio: "2",
      saveLoad: false,
      projectName: "",
      priceType: 1,
      priceUnit: "",
      price: "",
      count: "",
      remark: "",
      index: 0,
      danjia: "",
      addPrice: "",
      repairPrice: "",
      saved: false,
      totalPrice: 0,
    };
  },
  computed: {
    ...mapState([
      "idTypeList",
      "destineList",
      "payList",
      "contractList",
      "customerList",
      "contactList",
    ]),
    total: function () {
      // console.log('计算属性', this.message)
      let totalPrice = 0;
      this.constructDetail.forEach((item, index) => {
         if(!item.priceType){
          return 0
        }
        totalPrice += accMul(item.price , item.count)
        this.totalPrice = totalPrice;
      });
      return totalPrice + " 元";
    },
  },
  created() {
    // this.$nextTick(function () {
    //   this.getDetail();
    // });

    this.getDetail();
  },
  mounted() {},
  methods: {
    radioChange(e) {
      //   console.log(e)
      this.priceType = e;
      if (this.priceType) {
        if (this.priceType < 2) {
          this.danjia = this.addPrice + " " + this.priceUnit;
           this.price = this.addPrice 
        } else {
          this.danjia = this.repairPrice + " " + this.priceUnit;
          this.price = this.repairPrice 
        }
      }
    },
    getDetail() {
      const toast1 = this.$toast.loading({
        forbidClick: true,
        duration: 0,
        message: "加载中...",
      });
      this.decorationType = this.$route.query.decorationType;
      requestJointOrderConstructDetail(this.$route.query.id)
        .then((res) => {
          this.constructDetail = res.data.itemList;
         
          console.log(this.constructDetail);
          this.copyData = this._.cloneDeep(res.data.itemList);
          toast1.clear();
        })
        .catch((err) => {
          toast1.clear();
        });
    },
    // 保存
    submit() {
      requestJointOrderConstructDetailLast(this.$route.query.id)
        .then((res) => {
          this.saveLoad = false;
          this.compareData = deepClone(this.constructDetail);
          console.log(
            this.constructDetail.some(
              (item) => item.moduleId == 1454997126705213441
            )
          );
          this.constructFilter(this.compareData, res.data);
          for (let k = 0; k < this.constructDetail.length; k++) {
            if (
              this.constructDetail[k].count < 0 ||
              !this.constructDetail[k].priceType ||
              !this.constructDetail[k].priceUnit
            ) {
              this.$toast(
                `请完善施工项【${this.constructDetail[k].projectName}】信息`
              );
              return false;
            }
          }

          if (this.saved) {
            const obj = {};
            obj.totalPrice = this.totalPrice;
            obj.customerId = this.$route.query.id;
            obj.itemList = this.constructDetail;
            requestJointOrderConstructSaveOrUpdate(obj).then((res) => {
              this.$toast.success({
                message: "保存成功",
                forbidClick: true,
                onClose: () => {
                  this.$router.back();
                  // this.$router.push({ path: "contractList" });
                },
              });
            });
          }
        })
        .catch((err) => {
          this.saveLoad = false;
        });
    },
    tip(addList, deleteList, changeNew, changeOld) {
      console.log(addList, deleteList, changeNew, changeOld)
      if (
        addList.length ||
        deleteList.length ||
        changeNew.length ||
        changeOld.length
      ) {
        var message = "";
        for (let key of addList) {
          message += `增加施工项【${key.projectName}】\n`;
        }
        for (let key of deleteList) {
          message += `施工项【${key.projectName}】已移除\n`;
        }
        console.log(changeNew, changeOld);
        changeOld.forEach((item, index) => {
          // console.log(item)
          if (
            item.priceType == 1 &&
            item.price != changeNew[index].addPrice
          ) {
            message += `施工项【${item.projectName}】单价调整为${changeNew[index].addPrice}\n`;
          }
          if (
            item.priceType == 2 &&
            item.price != changeNew[index].repairPrice
          ) {
            message += `施工项【${item.projectName}】单价调整为${changeNew[index].repairPrice}\n`;
          }
        });
        // console.log(message)
        if (message.length > 0) {
          this.$dialog
            .alert({
              title: "提示",
              message,
            })
            .then(() => {});
        } else {
          this.saved = true;
        }
      } else {
        this.saved = true;
      }
    },
    constructFilter(oldList, newList) {
      let oldData = oldList.map((item) => {
        return {
          moduleId: item.moduleId,
          projectName: item.projectName,
          price: item.price,
        };
      });
      let newData = newList.map((item) => {
        return {
          moduleId: item.moduleId,
          projectName: item.projectName,
          price: item.price,
        };
      });
      let oldArr = [];
      let newArr = [];
      for (let i = 0; i < oldList.length; i++) {
        oldArr.push(oldList[i].moduleId);
      }
      for (let i = 0; i < newList.length; i++) {
        newArr.push(newList[i].moduleId);
      }
      let addArr = this._.difference(newArr, oldArr);
      let deleteArr = this._.difference(oldArr, newArr);
      //   console.log(addArr);
      let testarr = [];
      let testarr2 = [];
      let changeNewData = [];
      let changeOldData = [];
      if (addArr.length) {
        // 新增施工项渲染到列表
        for (let i = 0; i < addArr.length; i++) {
          newList.filter((item) => {
            if (item.moduleId == addArr[i]) {
              console.log(this.decorationType);
              if (this.decorationType == 1) {
                item.price = item.addPrice;
                item.priceType = 1;
              } else {
                item.price = "";
              }
              item.count = 0;
              testarr.push(item);
              console.log(item);

              this.constructDetail.unshift(item);
            }
          });
        }
      }
      if (deleteArr.length) {
        //移除被删除的施工项
        for (let i = 0; i < deleteArr.length; i++) {
          oldList.filter((item) => {
            if (item.moduleId == deleteArr[i]) {
              testarr2.push(item);
            }
          });
          for (let k = 0; k < this.constructDetail.length; k++) {
            for (let i = 0; i < deleteArr.length; i++) {
              if (this.constructDetail[k].moduleId == deleteArr[i]) {
                this.constructDetail.splice(k, 1);
              }
            }
          }
        }
      }
      console.log(oldList,1)
       console.log(newList,2)
        //过滤新数组中被修改的施工项
      for (let i = 0; i < oldList.length; i++) {
        for (let k = 0; k < newList.length; k++) {
          if (oldList[i].moduleId == newList[k].moduleId) {
             if(oldList[i].priceType == 1){
              if(oldList[i].price != newList[k].addPrice){
                 changeNewData.push(newList[k]);
              }
              }else{
                    if(oldList[i].price != newList[k].repairPrice){
                      changeNewData.push(newList[k]);
                    }
              }
          }
        }
      } 
     
      for (let i = 0; i < changeNewData.length; i++) {
        oldList.find((item) => {
          if (changeNewData[i].moduleId == item.moduleId) {
            changeOldData.push(item);
          }
        });
      } //旧数组中需要修改的施工项 用于提示
      this.tip(testarr, testarr2, changeNewData, changeOldData);
      // console.log(this.constructDetail,changeNewData)
      for (let i = 0; i < this.constructDetail.length; i++) {
        for (let k = 0; k < changeNewData.length; k++) {
          if (this.constructDetail[i].moduleId == changeNewData[k].moduleId) {
            // console.log("sanme")
            if (this.constructDetail[i].priceType < 2) {
              // console.log("te")
              this.constructDetail[i].price = changeNewData[k].addPrice;
              this.constructDetail[i].addPrice = changeNewData[k].addPrice;
            } else {
              this.constructDetail[i].price = changeNewData[k].repairPrice;
              this.constructDetail[i].repairPrice =
                changeNewData[k].repairPrice;
            }
          }
        }
      }
    },
    construct(item, index) {
      this.index = index;
        console.log(this.constructDetail[index]);
      this.projectName = this.constructDetail[index].projectName;
      this.priceType = this.constructDetail[index].priceType + "";
      this.addPrice = this.constructDetail[index].addPrice;
      this.repairPrice = this.constructDetail[index].repairPrice;
      this.count = this.constructDetail[index].count;
      this.remark = this.constructDetail[index].remark;
      this.priceUnit = this.constructDetail[index].priceUnit;
       this.price = this.constructDetail[index].price;
      // console.log(this.priceType)
      if (this.priceType == 1) {
        this.danjia =
          this.constructDetail[index].addPrice +
          this.constructDetail[index].priceUnit;
      } else if (this.priceType == 2) {
        this.danjia =
          this.constructDetail[index].repairPrice +
          this.constructDetail[index].priceUnit;
      } else {
        this.priceType = null;
        this.danjia = "";
      }
      //  if ( this.priceType == 'null') {
      //   // //    this.addPrice = ''
      //   // //    this.repairPrice = ''
      // } else
      // console.log(this.danjia)
      //   console.log(this.priceType)
      //   if(this.priceType<2){
      //       this.danjia = this.addPrice +
      //         " " +
      //         this.constructDetail[this.index].priceUnit
      //   }
      this.showEdit = true;
    },
    cancel() {
      this.showEdit = false;
      this.priceType = null;
      this.count = "";
      this.remark = "";
      // console.log(this.constructDetail);
      return false;
    },
      validNum0(val) {
      return validNum0(val);
    },
    onSubmitForm() {
      // console.log(this.priceType)
      if (this.priceType == null || this.priceType == "") {
        this.$toast("请选择施工项类型");
        return false;
      }
      this.constructDetail[this.index].price = this.price;
      this.constructDetail[this.index].projectName = this.projectName;
      this.constructDetail[this.index].priceType = this.priceType;
      this.constructDetail[this.index].addPrice = this.addPrice;
      this.constructDetail[this.index].repairPrice = this.repairPrice;
      this.constructDetail[this.index].count = this.count;
      this.constructDetail[this.index].remark = this.remark;
      this.constructDetail[this.index].priceUnit = this.priceUnit;
      // console.log(this.constructDetail);
      this.showEdit = false;
    },
  },

  destroyed() {},
  watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
#jointOrderConstruct {
  .btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
      margin-left: -1px;
      border: none;
      border-radius: 0;
      flex: 1;
      &:not(:last-child)::after {
        height: 50%;
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        border-right: 0.02667rem solid #ebedf0;
        z-index: 99;
      }
    }
  }
  .construct_list {
    background: #fff;

    .top {
      padding: 0.26667rem 0.42667rem;
      position: relative;
    }
    .top::after {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0rem;
      bottom: 0;
      left: 0rem;
      border-bottom: 0.02667rem solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
    .top li {
      width: 18%;
      position: relative;
    }
    .top li:nth-of-type(1) {
      // width:30%;
      //  flex:1;
      text-align: left;
    }
    .list li {
      padding: 0.26667rem 0.42667rem;
      position: relative;
    }
    .list li:after {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0rem;
      bottom: 0;
      left: 0rem;
      border-bottom: 0.02667rem solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
    .list li span {
      width: 18%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .list li span:nth-of-type(1) {
      // width:30%;
      // flex:1;
      text-align: left;
    }
  }
}
</style>
